import React from 'react';
import Fab from '@material-ui/core/Fab';
import Down from '@material-ui/icons/KeyboardArrowDown';
import { Link, animateScroll as scroll } from 'react-scroll';



function how(){
    return(
        <div style={{width: "100%", position: "absolute"}}>
        <Link className="seeMore" activeClass="active" to="more" spy={true} smooth={true} offset={-40} duration={500} style={{cursor: "pointer"}}>
           <Fab color="primary" aria-label="add" style={{outline: "none"}}>
                <Down />
            </Fab>
        </Link>
        </div>
    )
}

export default how;